import { useEffect, useState } from 'react';

const PRIVACY_STATIC_PATH = '/legal/privacy/index.html';

export function PrivacyPage() {
  const [privacyHtml, setPrivacyHtml] = useState<string>('');
  const [loadError, setLoadError] = useState(false);

  useEffect(() => {
    let isMounted = true;

    fetch(PRIVACY_STATIC_PATH, { credentials: 'same-origin' })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to load Privacy Policy (${response.status})`);
        }
        return response.text();
      })
      .then((html) => {
        if (isMounted) {
          setPrivacyHtml(html);
        }
      })
      .catch(() => {
        if (isMounted) {
          setLoadError(true);
        }
      });

    return () => {
      isMounted = false;
    };
  }, []);

  if (loadError) {
    return (
      <main className="min-h-screen bg-white p-8 text-slate-800">
        <h1 className="text-2xl font-semibold">Privacy Policy</h1>
        <p className="mt-3">
          The Privacy Policy could not be loaded in this view. You can open it directly at{' '}
          <a className="text-blue-600 underline" href={PRIVACY_STATIC_PATH}>
            {PRIVACY_STATIC_PATH}
          </a>
          .
        </p>
      </main>
    );
  }

  if (!privacyHtml) {
    return (
      <main className="min-h-screen bg-white p-8 text-slate-800">
        <p>Loading Privacy Policy...</p>
      </main>
    );
  }

  return <main className="min-h-screen bg-white" dangerouslySetInnerHTML={{ __html: privacyHtml }} />;
}
